import React, { useEffect, useState } from "react";
import axios from "axios";
import { imgUrl } from "../admin/adminApi";
import { useCart } from "../context/CartContext";
import { discounted } from "./ServicesSection";
import Carousel from "./Carousel";
import { Button } from "./ui/button";
import { Plus, Check, Flame } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Card = ({ s }) => {
  const { addToCart, items } = useCart();
  const inCart = items.find((i) => i.name === s.name);
  const dp = discounted(s);
  return (
    <div className="w-52 md:w-[23%] md:min-w-[220px] shrink-0 snap-start bg-white rounded-2xl ring-1 ring-black/5 shadow-sm overflow-hidden svc-card">
      <div className="img-zoom-wrap relative h-36 overflow-hidden">
        <img src={imgUrl(s.image)} alt={s.name} className="img-zoom w-full h-full object-cover" />
        <span className="absolute top-2 left-2 bg-accent text-white text-[10px] font-bold px-2 py-0.5 rounded-full flex items-center gap-1"><Flame className="w-3 h-3" /> Most Booked</span>
      </div>
      <div className="p-3">
        <h4 className="font-semibold text-gray-900 text-sm leading-tight line-clamp-1">{s.name}</h4>
        <div className="flex items-center gap-2 mt-1">
          {dp != null ? (<><span className="font-bold text-primary text-sm">₹{dp}</span><span className="line-through text-gray-400 text-xs">₹{s.price}</span></>) : <span className="font-bold text-primary text-sm">₹{s.price}</span>}
        </div>
        <Button size="sm" onClick={() => addToCart({ name: s.name, price: dp != null ? dp : s.price, type: "service" })} disabled={!!inCart} className="w-full mt-2 h-8 rounded-full bg-primary hover:bg-primary/90 text-xs">
          {inCart ? <><Check className="w-3.5 h-3.5 mr-1" /> Added</> : <><Plus className="w-3.5 h-3.5 mr-1" /> Add</>}
        </Button>
      </div>
    </div>
  );
};

const MostBooked = () => {
  const [list, setList] = useState([]);
  useEffect(() => { axios.get(`${API}/services`).then((r) => setList(r.data.filter((s) => s.most_booked))).catch(() => {}); }, []);
  if (list.length === 0) return null;
  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="flex items-center gap-2 mb-6"><Flame className="w-6 h-6 text-accent" /><h2 className="font-display text-2xl md:text-3xl font-bold text-gray-900">Most Booked Services</h2></div>
        <Carousel>
          {list.map((s) => <Card key={s.id} s={s} />)}
        </Carousel>
      </div>
    </section>
  );
};

export default MostBooked;
